module.exports = __webpack_public_path__ + "img/webhook.64ee0985.svg";